export default "__VITE_ASSET__DxpofhTv__"